import React, { createContext, useContext } from 'react';
import { useQuery } from 'react-query';
import { userAPI } from '../api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const { data, error, isLoading } = useQuery('currentUser', userAPI.getUser, {
    // Don't retry on 401 - it means user is not authenticated
    retry: false,
    // Stale time of 5 minutes - reduce unnecessary API calls
    staleTime: 5 * 60 * 1000,
    // Handle errors gracefully - unauthenticated state is not an error
    onError: () => {
      // Silent failure - this is expected for unauthenticated users
    }
  });

  const tenantData = data?.tenant || error?.response?.data?.tenant;

  return (
    <AuthContext.Provider
      value={{
        userData: data?.user,
        isLoading,
        isLoggedIn: !!data?.user,
        isCarneyTeam: data?.user?.is_carney_team,
        isEmployee: data?.user?.is_employee,
        accessType: data?.user?.profile?.hubspot?.access_type,
        hasFullAccess: data?.user?.has_full_access,
        isTenant: Boolean(tenantData && tenantData?.slug !== 'public'),
        tenant: tenantData,
        isAdmin: data?.user?.roles?.includes('admin'),
        expires_at: data?.user?.expires_at,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

// Create a custom hook to use the AuthContext, call it useAuth
function useAuth() {
  return useContext(AuthContext);
}

export default useAuth;
